import type { RideApiStop } from "@/types/rideDetails";

/** Hours after route end (ep) before booking is closed. */
export const RIDE_END_GRACE_HOURS = 2;

const RIDE_END_GRACE_MS = RIDE_END_GRACE_HOURS * 60 * 60 * 1000;

type StopSchedule = Pick<RideApiStop, "dt" | "tm">;

/** Parses API `dt` + `tm` (route stop local schedule) into a Date. */
export function parseApiStopDateTime(
  dt?: string,
  tm?: string
): Date | null {
  if (!dt?.trim() || !tm?.trim()) return null;

  const time = tm.trim();
  const normalizedTime =
    /^\d{1,2}:\d{2}$/.test(time) ? `${time}:00` : time;

  const parsed = new Date(`${dt.trim()}T${normalizedTime}`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/**
 * True when `now` is at least {@link RIDE_END_GRACE_HOURS} after the route **end**
 * stop datetime (`ep.dt` + `ep.tm`) — not the start time.
 */
export function isRideCompletedAfterEnd(
  endStop?: StopSchedule | null,
  now: Date = new Date()
): boolean {
  const endAt = parseApiStopDateTime(endStop?.dt, endStop?.tm);
  if (!endAt) return false;
  return now.getTime() >= endAt.getTime() + RIDE_END_GRACE_MS;
}
